import { useEffect, useState } from "react";
import ContentCancellation from "./ContentCancellation";
import WrapperPopup from "../WrapperPopup";
import {
  parsCancellationPolicy,
  checkFreeCancellation,
  checkDoesNotReturn,
  checkNonRefundableRate,
  fnSwitchDateFreeCancellation,
} from "./helperFnCancellationPolicy";
import "../style-mobile.css";
import { DiscriptCancellation } from "./DiscriptCancellation";
import { colorTextFreeCancellation } from "./dataHelperCancellation";

const BlockCancellation = ({
  positionProps,
  customTooltipCancellation,
  arrowStyleCancellation,
  props,
}) => {
  const [arrayCancellationPolicy, setArrayCancellationPolicy] = useState(null);
  useEffect(() => {
    setArrayCancellationPolicy(() => parsCancellationPolicy(props));
  }, []);

  const BlockTriggerCancellation = () => {
    const switchTriggerCancellation = (elem) => {
      const valueCheckTrigger = () => {
        if (checkFreeCancellation(elem)) {
          return 0;
        }
        if (checkDoesNotReturn(elem)) {
          return 1;
        }
        if (checkNonRefundableRate(elem)) {
          return 2;
        }
        return 4;
      };

      switch (valueCheckTrigger()) {
        case 0:
          return (
            <DiscriptCancellation
              iconStatus={true}
              contentColor={colorTextFreeCancellation?.[0]}
              text={`Бесплатная отмена до <nobr>${fnSwitchDateFreeCancellation(arrayCancellationPolicy)}</nobr>`}
            />
          );
        case 1:
          return (
            <DiscriptCancellation
              iconStatus={true}
              contentColor={colorTextFreeCancellation?.[1]}
              text={"Условия отмены"}
            />
          );

        case 2:
          return (
            <DiscriptCancellation
              iconStatus={false}
              contentColor={colorTextFreeCancellation?.[2]}
              text={"Невозвратный тариф"}
            />
          );
        default:
          return <></>;
      }
    };

    return (
      <div className="block-cancellation_policy">
        {switchTriggerCancellation(arrayCancellationPolicy)}
      </div>
    );
  };

  return (
    <>
      {arrayCancellationPolicy !== null &&
      arrayCancellationPolicy !== undefined ? (
        <>
          {(arrayCancellationPolicy.length === 1) &
          (arrayCancellationPolicy[0]?.color === 3) ? (
            <BlockTriggerCancellation />
          ) : (
            <WrapperPopup
              positionProps={positionProps}
              contentStyleProps={customTooltipCancellation}
              triggerProps={BlockTriggerCancellation}
              arrowStyleProps={arrowStyleCancellation}
            >
              <ContentCancellation
                arrayCancellationPolicy={arrayCancellationPolicy}
              />
            </WrapperPopup>
          )}
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export { BlockCancellation };
